import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'

const PageContainer = forwardRef((props, ref) => {
  return (
    <ImportTouchDesk
      touch={() => import('./layout/PageContainer.mobile')}
      desktop={() => import('./layout/PageContainer.desktop')}
    >
      {Component => <Component {...props} ref={ref} />}
    </ImportTouchDesk>
  )
})
export default PageContainer
PageContainer.propTypes = {
  headerProps: PropTypes.shape({
    rightComponent: PropTypes.node
  })
}
